import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Dots } from "react-activity";
import * as url from "../../helpers/url_helper";
import { setBreadcrumbItems } from "../../store/actions";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import logoVSP from "../../assets/images/VUF-Logo-curve.svg";
import VUF_TEMP from "../../assets/images/VUF_temple.jpg";
import TEMP from "../../assets/images/temple.jpg";
import QRCode from "react-qr-code";

const RegisterEvent = (props) => {
  const { id, show } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [mobileNo, setMobileNo] = useState(null);
  const [isValidMobileNo, setIsValidMobileNo] = useState(true);
  const [eventList, setEventList] = useState([]);
  const [bannerShow, setBannerShow] = useState("");
  const [eventUser, setEventUser] = useState(null);
  const [age, setAge] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [eventId, setEventID] = useState("");
  const [userId, setUserID] = useState(null);
  const [mode, setMode] = useState(null);
  const [event, setEvent] = useState(null);
  const [locationDetails, setlocationDetails] = useState(null);
  const [countries, setcountries] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setdistrictList] = useState([]);
  const [CityList, setCityList] = useState([]);

  const [selectedCity, setselectedCity] = useState(null);
  const [selectedCountry, setselectedCountry] = useState(null);
  const [selectedDistrict, setselectedDistrict] = useState(null);
  const [selectedState, setselectedState] = useState(null);
  const [IsRegistrationOpen, setIsRegistrationOpen] = useState(true);
  const [street_address, setstreet_address] = useState(null);
  const [areas, setareas] = useState([]);
  const [errors, seterrors] = useState({});
  const [IsRegister, setIsRegister] = useState(false);
  const [isNumberRegister, setisNumberRegister] = useState(false);

  const [firstName, setfirstName] = useState(null);
  const [lastName, setlastName] = useState(null);
  const [enableInput, setenableInput] = useState(true);
  const [remark, setremark] = useState(null);
  const [area, setarea] = useState(null);
  const [addressComponent, setaddressComponent] = useState(null);
  const [Pincode, setPincode] = useState(null);
  const [QRCodeValue, setQRCodeValue] = useState("");
  const [ccode, setccode] = useState("+91");
  const [divImage, setdivImage] = useState(VUF_TEMP);

  useEffect(() => {
    setEventID(id);
    setBannerShow(id);

    function getEvent() {
      let urlPath = "event/eventdetails/" + id;

      fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData.status) {
            var dataRes = responseData.data;
            setEvent(dataRes);
            setlocationDetails(responseData.location);

            if (
              dataRes.eventBannerImage != null &&
              dataRes.eventBannerImage != ""
            ) {
              setdivImage(url.VUF_APP_BANNER_URL + dataRes.eventBannerImage);
            }

            var current = new Date();
            var RegstartD = new Date(dataRes.registrationStartDate);
            var RegendD = new Date(dataRes.registrationEndDate);
            if (RegstartD <= current && RegendD >= current) {
              setIsRegistrationOpen(true);

              if (dataRes.MaxRegistration > 0) {
                if (dataRes.MaxRegistration >= responseData.UserCount) {
                  setIsRegistrationOpen(false);
                }
              }
            } else {
              setIsRegistrationOpen(false);
            }

            if (dataRes.RegistrationOpen == "true") {
              setIsRegistrationOpen(true);
            }
            // eventName= dataRes.eventName
            // eventStartDate= new Date(dataRes.eventStartDate)
            // eventEndDate= new Date(dataRes.eventEndDate)
            // registrationStartDate= new Date(dataRes.registrationStartDate)
            // registrationEndDate= new Date(dataRes.registrationEndDate)
          } else {
            alert("Something went wrong, Please try again after sometime.");
            // this.setState({ loading: false });
          }
        })
        .catch((error) => {
          console.log("err", error);
          alert("Something went wrong, Please try again after sometime.");
          // this.setState({ loading: false });
        })
        .finally((final) => {
          // return this.setState({ isInvitingUser: false })
        });
    }
    getEvent();
  }, []);

  const handleMobileNoChange = (event) => {
    const newMobileNo = event.target.value;

    // Regular expression for exactly 10 numeric characters
    const numericRegex = /^[0-9]{0,10}$/;

    // Validate the input against the regular expression
    const isValid = numericRegex.test(newMobileNo);

    // Update the isValidMobileNo state based on the validation result
    setIsValidMobileNo(isValid);

    // If the input is valid or empty, and the length is less than or equal to 10, update the mobileNo state
    if ((isValid || newMobileNo === "") && newMobileNo.length <= 10) {
      setMobileNo(newMobileNo);
    }
  };
  function handleValidation() {
    let errors = {};
    let formIsValid = true;

    if (firstName?.trim() === "" && lastName?.trim() === "") {
      formIsValid = false;
      errors.firstName = "Please enter full name";
    }

    // if (lastName?.trim() === "") {
    //   formIsValid = false;
    //   errors.lastName = "Please enter last name";
    // }
    const regexPin = /^\d{0,5}$/;
    if (Pincode?.trim() === "") {
      formIsValid = false;
      errors.Pincode = "Please enter Pincode";
    } else if (regexPin.test(Pincode)) {
      formIsValid = false;
      errors.Pincode = "Please enter 6 digit Pincode";
    }
    if (street_address?.trim() === "") {
      formIsValid = false;
      errors.Pincode = "Please enter correct Pincode";
    }

    // if (this.state.ccode?.trim() === "") {
    //     formIsValid = false;
    //     errors.ccode = "Please enter country code";
    // }

    // if (this.state.email?.trim() === "") {
    //     formIsValid = false;
    //     errors.email = "Please enter email address";
    // }

    if (mobileNo?.trim() === "") {
      formIsValid = false;
      errors.mobileNo = "Please enter mobile number";
    }

    console.log(errors);

    seterrors(errors);

    return formIsValid;
  }
  function reset() {
    setQRCodeValue("");
    setMobileNo("");
    seterrors({});
    setfirstName("");
    setlastName("");
    setarea("");
    setareas([]);
    setPincode("");
    setstreet_address("");
    setaddressComponent(null);
    setAge("");
    setBloodGroup("");
  }

  async function onGetCountryList() {
    let urlPath = "auth/CountryList";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        // // // console.log("RES ",responseData)
        if (responseData.status) {
          var data = responseData.response;

          let countriesdata = [];

          data.map((c, i) => {
            countriesdata.push({
              label: c.country_name,
              id: c._id,
              Code: c.id,
            });
          });

          setcountries(countriesdata);

          if (selectedCountry != "" && selectedCountry != null) {
            let stateCode = countries.filter(
              (s) => s.label == selectedCountry
            )[0].Code;
            onGetStateList(stateCode);
          } else {
            selectedCity = "";
            selectedDistrict = "";
            selectedState = "";
          }
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }
  function onGetStateList(data) {
    if (data != null && data != "") {
      let urlPath = "auth/StatesList/" + data;

      fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: Body,
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          // // // console.log("RES ",responseData)
          if (responseData.status) {
            var resp = responseData.response;

            let stateListdata = [];

            resp.map((c, i) => {
              stateListdata.push({
                label: c.state_title,
                id: c._id,
                Code: c.state_id,
              });
            });
            setStateList(stateListdata);

            if (selectedState != "" && selectedState != null) {
              let stateCode = stateList.filter(
                (s) => s.label == selectedState
              )[0].Code;
              onGetDistrictList(stateCode);
            } else {
              selectedState = "";
              selectedDistrict = "";
              selectedCity = "";
            }
          }
        })
        .catch((error) => {
          // // console.log("err", error);
        })
        .finally((final) => {
          //return this.setState({ loading: false })
        });
    }
  }
  function onGetDistrictList(data) {
    let urlPath = "auth/DistrictsList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        // // // console.log("RES ",responseData)
        if (responseData.status) {
          var dataRes = responseData.response;
          let districtListdata = [];

          dataRes.map((c, i) => {
            districtListdata.push({
              label: c.district_title,
              id: c._id,
              Code: c.districtid,
            });
          });

          setdistrictList(districtListdata);

          if (selectedDistrict != "" && selectedDistrict != null) {
            let districtCode = districtList.filter(
              (s) => s.label == selectedDistrict
            )[0].Code;
            onGetCitiesList(districtCode);
          } else {
            selectedDistrict = "";
            selectedCity = "";
          }
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {
        // return this.setState({ loading: false })
      });
  }
  function onGetCitiesList(data) {
    let urlPath = "auth/CitiesList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        // // // console.log("RES ",responseData)
        if (responseData.status) {
          var dataRes = responseData.response;
          let CityListdata = [];

          dataRes.map((c, i) => {
            CityListdata.push({ label: c.name, id: c._id, Code: c.id });
          });

          setCityList(CityListdata);
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {
        //return this.setState({ loading: false })
      });
  }
  function onChangePostcode(e) {
    if (e != null && e != "") {
      let urlPath = "auth/PostalCode/" + e;

      fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData.status) {
            if (
              responseData.response[0].PostOffice != null &&
              responseData.response[0].PostOffice.length > 0
            ) {
              var data = responseData.response[0].PostOffice[0];
              setselectedCountry(data.Country);
              setselectedCity(data.Block);
              setselectedDistrict(data.District);
              setselectedState(data.State);
              setstreet_address(
                data.Country +
                  ", " +
                  data.State +
                  ", " +
                  data.District +
                  ", " +
                  data.Block
              );
              var areadata = area;
              let areas = [];
              responseData.response[0].PostOffice.map((c, i) => {
                areas.push({ label: c.Name, id: c.Name, Code: c.Name });
                if (areadata == c.Name) {
                  setarea({ label: c.Name, id: c.Name, Code: c.Name });
                }
              });
              setareas(areas);
            }
          }
        })
        .catch((error) => {
          console.log("err", error);
          alert("Something went wrong, Please try again after sometime.");
        });
    } else {
    }
  }
  function checkMobileNumberIsRegistered(event) {
    const inputValue = event.target.value;
    const regex = /^\d{0,10}$/; // Regex to match exactly 10 digits
    setMobileNo(inputValue);
    if (regex.test(inputValue) && inputValue.length == 10) {
      numberCheckAPI();
      //onUserInvite(event)
    } else {
      seterrors({ isNumberVerified: false });
    }
  }

  async function numberCheckAPI() {
    try {
      const response = await fetch(
        url.VUF_APP_API + "auth/check-mobile-eventRegistered",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            countryCode: ccode,
            eventId,
            mobileNo: mobileNo.toString().trim(),
            client: url.AUTH_APP_NAME,
            client_secret: url.AUTH_SECRET,
          }),
        }
      );

      const responseData = await response.json();
      let errors = {};
      setenableInput(true);
      setisNumberRegister(true);

      if (responseData.response) {
        const user = responseData.response.user;
        const event = responseData.response.event;

        if (user) {
          errors.mobileNo = "User already registered.";
          setfirstName(user.firstName);
          setUserID(user._id);
          setenableInput(false);
          setremark(user.remarks);
          setselectedCity(user.city);
          setselectedCountry(user.country);
          setselectedDistrict(user.district);
          setselectedState(user.state);
          setarea(user.area);
          setaddressComponent(user.street_address);
          setPincode(user.Pincode);
          setBloodGroup(user.bloodgroup);
          setAge(user.age);
          //if (user.Pincode) onChangePostcode(user.Pincode);
        }

        if (event) {
          errors.mobileNo = "User already registered in event.";
          setQRCodeValue(user ? user._id + "_" + event._id : "");
          setIsRegister(true);
        }
        seterrors(errors);
      }
    } catch (error) {
      console.log("err", error);
      alert("Something went wrong, Please try again after sometime.");
      seterrors({ mobileNo: "Something went wrong." });
    }
  }
  function onUserInvite(e) {
    if (!handleValidation()) {
      return false;
    }
    e.preventDefault();
    if (isNumberRegister == false) {
      const Body = JSON.stringify({
        firstName: firstName,
        lastName: lastName,
        mobileNo: mobileNo,
        remarks: remark || "",
        street_address: street_address,
        addressComponent: addressComponent,
        countryCode: ccode,
        client: url.AUTH_APP_NAME,
        client_secret: url.AUTH_SECRET,
        city: selectedCity || "",
        district: selectedDistrict || "",
        state: selectedState || "",
        Pincode: Pincode || "",
        country: selectedCountry || "",
        area: area?.label || "",
        age: age,
        bloodgroup: bloodGroup,
      });

      let urlPath = "eventUser";

      fetch(url.AUTH_URL + urlPath, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer SECRET",
        },
        body: Body,
      })
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData.status && responseData.response) {
            setUserID(responseData.response.user._id);

            setTimeout(() => {
              UserEventCreate(e);
            }, 100);
          } else if (!responseData.status && responseData.error) {
            console.log(responseData?.error || "Error");
          } else {
            alert("Something went wrong, Please try again after sometime.");
          }
        })
        .catch((error) => {
          console.log("err", error);
          alert("Something went wrong, Please try again after sometime.");
        })
        .finally((final) => {
          // return this.setState({ isInvitingUser: false })
        });
    } else {
      const Body = JSON.stringify({
        firstName: firstName,
        // lastName: lastName,
        remarks: remark || "",
        street_address: street_address,
        countryCode: ccode,
        client: url.AUTH_APP_NAME,
        client_secret: url.AUTH_SECRET,
        city: selectedCity || "",
        district: selectedDistrict || "",
        state: selectedState || "",
        Pincode: Pincode || "",
        country: selectedCountry || "",
        area: area.label || "",
        age: age || "",
        bloodgroup: bloodGroup,
      });
      let urlPath = "userPincodeupdate/" + userId;

      fetch(url.AUTH_URL + urlPath, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer SECRET",
        },
        body: Body,
      })
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData.status) {
            setTimeout(() => {
              UserEventCreate(e);
            }, 100);
          } else if (!responseData.status && responseData.error) {
            alert(responseData?.error || "Error");
          } else {
            alert("Something went wrong, Please try again after sometime.");
          }
        })
        .catch((error) => {
          console.log("err", error);
          alert("Something went wrong, Please try again after sometime.");
          //this.setState({ loading: false });
        })
        .finally((final) => {});
    }
  }
  function UserEventCreate(e) {
    const Body = JSON.stringify({
      userId: userId,
      eventId: eventId,
      firstName: firstName,
      lastName: lastName,
      mobileNo: mobileNo.trim(),
      Pincode: Pincode,
      addressComponent: addressComponent || "",
      countryCode: ccode,
      client: url.AUTH_APP_NAME,
      client_secret: url.AUTH_SECRET,
      city: selectedCity || "",
      district: selectedDistrict || "",
      state: selectedState || "",
      country: selectedCountry || "",
      area: area.label || "",
      age: age,
      bloodgroup: bloodGroup,
      mode: "QR",
    });
    let urlPath = "event/registerEvent";

    fetch(url.VUF_APP_API + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer SECRET",
      },
      body: Body,
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status && responseData.response) {
          alert("Event Register Successfully.");
          setQRCodeValue(
            responseData.response.userId + "_" + responseData.response.eventId
          );
        } else if (!responseData.status && "auth" in responseData) {
        } else if (!responseData.status && responseData.error) {
          alert(responseData?.error || "Error");
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
        //this.setState({ loading: false });
      })
      .finally((final) => {
        // return this.setState({ isInvitingUser: false })
      });
  }

  const formatDate = (stdate) => {
    if (stdate != null) {
      const date = new Date(stdate); // 8th September 2024 (Month is 0-based, so 8 represents September)
      const options = { day: "numeric", month: "long" };
      return date.toLocaleDateString("en-GB", options); // "8 September"
    }
  };
  //   loading
  //   ?
  //   <div className="col-md-12" style={{ height: '100%', justifyContent: 'center', alignContent: 'center', display: 'flex' }}><Dots /></div>
  //   :

  return (
    <>
      <div>
        {/* Header with Logo and Event Title */}
        <header className="header">
          <img src={logoVSP} alt="Vishv Umiya Logo" className="logo" />
          <h1>Event Registration</h1>
        </header>

        {/* Banner with Background Image and Event Details */}
        {show != null && (
          <div>
            {id && (
              <div
                className="banner"
                style={{
                  backgroundImage: "url(" + divImage + ")",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  width: "100%",
                  height: "350px",
                }}
              >
                {event != null && (
                  <div className="">
                    <h2>{event.eventName}</h2>
                    <p>{formatDate(event.eventStartDate)}</p>
                    <p>
                      Venue:{" "}
                      {event != null && event.Address != null ? (
                        <span> {event.Address} </span>
                      ) : (
                        <span>
                          {" "}
                          Country - {event.country}. State - {event.state}. City
                          - {event.city}{" "}
                        </span>
                      )}
                      {this.state.locationDetails != null && (
                        <span>{this.state.locationDetails.name}</span>
                      )}
                    </p>
                  </div>
                )}
              </div>
            )}
            {show &&
              event.eventBannerImage != null &&
              event.eventBannerImage != "" && (
                <div
                  className="bannerimg"
                  style={{ backgroundImage: "url(" + divImage + ")" }}
                ></div>
              )}
          </div>
        )}

        {/* <div  style={{ backgroundImage: `url("../assets/images/vuf-border.png") `,backgroundRepeat:'repeat' }}>
</div> */}
        <div class="temple-border"></div>
        {/* <img src="../assets/images/vuf-border.png" style={{backgroundRepeat:'repeat-x',backgroundSize:'auto 40px'}} alt="border Image" class="temple-border" /> */}
        {/* Registration Form */}
        <div className="container">
          {IsRegistrationOpen == true ? (
            <div className="card-body row" style={{ paddingTop: 10 }}>
              <div className="col-md-12 border-right-desktop-deprecated">
                {/* <div className='col-md-12' style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                            <label style={{ textAlign: 'center', width: '100%', fontSize: 23, fontWeight: '700', color: '#bc2f30', marginBottom: 10 }}>VUF Event Registration</label>
                                        </div> */}
              </div>

              {loading ? (
                <div
                  className="col-md-12"
                  style={{
                    height: "100%",
                    justifyContent: "center",
                    alignContent: "center",
                    display: "flex",
                  }}
                >
                  <Dots />
                </div>
              ) : (
                <>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-12 col-lg-12">
                        <label>Mobile Number / મોબાઇલ નંબર:</label>
                        <div className="row">
                          <div className="col-3  col-md-2">
                            <input
                              type="text"
                              name="ccode"
                              disabled="true"
                              className="form-control p-1 form-control-solid"
                              placeholder="+91"
                              value={ccode}
                            />
                            <span className="form-text text-danger">
                              {errors?.ccode}
                            </span>
                          </div>
                          <div className="col-9 col-md-10">
                            <input
                              type="text"
                              name="mobileNo"
                              disabled={QRCodeValue != ""}
                              className="form-control form-control-solid"
                              placeholder="Mobile number"
                              onChange={handleMobileNoChange}
                              onBlur={(event) =>
                                checkMobileNumberIsRegistered(event)
                              }
                              value={mobileNo}
                            />
                            <span className="form-text text-danger">
                              {errors?.mobileNo}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {QRCodeValue == "" && (
                      <div className="row">
                        <div className="col-12 col-lg-6">
                          <label>Full Name / નામ:</label>
                          <input
                            type="text"
                            name="firstName"
                            disabled={!enableInput}
                            className="form-control form-control-solid"
                            onChange={(event) =>
                              setfirstName(event.target.value)
                            }
                            placeholder="Enter full name"
                            value={firstName}
                          />
                          <span className="form-text text-danger">
                            {errors?.firstName}
                          </span>
                        </div>

                        <div className="col-12 col-lg-3">
                          <label>Blood Group / બ્લડ ગ્રુપ:</label>
                          <input
                            type="text"
                            name="bloodgroup"
                            className="form-control form-control-solid"
                            onChange={(event) =>
                              setBloodGroup(event.target.value)
                            }
                            placeholder="Enter blood group"
                            value={bloodGroup}
                          />
                          <span className="form-text text-danger">
                            {errors?.bloodGroup}
                          </span>
                        </div>
                        <div className="col-12 col-lg-3">
                          <label>Age / ઉંમર</label>
                          <input
                            type="text"
                            name="age"
                            minLength={1}
                            maxLength={2}
                            pattern="^[0-9]+$"
                            className="form-control form-control-solid"
                            onChange={(event) => {
                              const value = event.target.value;
                              if (/^[0-9]*$/.test(value)) {
                                setAge(value);
                              }
                            }}
                            placeholder="Enter Age"
                            value={age}
                          />
                          <span className="form-text text-danger">
                            {errors?.age}
                          </span>
                        </div>
                      </div>
                    )}{" "}
                    {QRCodeValue == "" && (
                      <div className="row">
                        <div className="col-md-6">
                          <label>Pincode / પિનકોડ: </label>
                          <input
                            type="text"
                            name="Pincode"
                            className="form-control form-control-solid"
                            onBlur={(event) => {
                              onChangePostcode(event.target.value);
                            }}
                            onChange={(event) => setPincode(event.target.value)}
                            placeholder="Pincode"
                            value={Pincode}
                          />
                          <span className="form-text text-danger">
                            {errors?.Pincode}
                          </span>
                        </div>
                        <div className="col-md-4">
                          <label>
                            Country / દેશ, State / રાજ્ય, District / જિલ્લો,
                            City / શહેર{" "}
                          </label>

                          <input
                            type="text"
                            name="street_address"
                            disabled="true"
                            className="form-control form-control-solid"
                            value={street_address}
                          />
                        </div>
                        <div className="col-md-2">
                          <label>Area / વિસ્તાર (Optional): </label>

                          <Select
                            disabled={!enableInput}
                            onChange={(event) => setarea(event)}
                            classNamePrefix="select2-selection"
                            value={area}
                            options={areas}
                          />
                        </div>
                      </div>
                    )}{" "}
                    {QRCodeValue == "" && (
                      <div className="row">
                        <div className="col-md-6">
                          <label>Address / સરનામું (Optional):</label>
                          <textarea
                            disabled={!enableInput}
                            type="text"
                            name="addressComponent"
                            className="form-control form-control-solid"
                            placeholder="Enter Address"
                          >
                            {addressComponent}
                          </textarea>
                          <span className="form-text text-danger">
                            {errors?.addressComponent}
                          </span>
                        </div>
                      </div>
                    )}
                    {QRCodeValue != "" && (
                      <div className="text-center  mt-2">
                        <span className="h5">Thank you for Registration!!</span>{" "}
                        <br />
                        <h1>Scan Registration OR</h1>
                        <QRCode
                          // size={256}
                          //style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                          value={QRCodeValue}
                          // viewBox={`0 0 256 256`}
                        />
                        <br />
                        <br />
                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          onClick={(event) => reset()}
                        >
                          Reset
                        </button>
                      </div>
                    )}
                    {IsRegistrationOpen == true && QRCodeValue == "" ? (
                      <div
                        className="col-md-12 text-center"
                        style={{ paddingTop: 20, marginBottom: 0 }}
                      >
                        <div className="col-md-21 col-sm-12 col-sm-12 margin-top-mob">
                          <div className=" text-center">
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              onClick={(event) => onUserInvite(event)}
                            >
                              Register Now
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className="card-body text-center">
              <div
                style={{
                  backGround: "#ffe6e6",
                  color: "#b71c1c",
                  border: "1px solid #f5c2c2",
                  padding: "15px 20px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "500",
                  display: "inlineBlock",
                }}
              >
                <p>🚫 Registrations for this event are now closed.</p>
              </div>
            </div>
          )}
        </div>

        {/* Footer with Red Background and Footer Image */}
        {/* <div className='temple-image'>
    <img src="../assets/images/temple.jpg" alt="Temple Image" class="" />
</div> */}
        <div style={{ marginLeft: "80%" }}>
          <img src={TEMP} alt="Temple Image" class="temple-image" />
        </div>
        <div class="reg-footer">
          <p class="iso">ISO 9001:2015 Approval Number: 00044220</p>
          <p class="copyright">
            Copyright © 2024 Vishv Umiya Foundation. All Rights Reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default connect(null, { setBreadcrumbItems })(RegisterEvent);
